import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "../css/SchoolCurricula.css";

const SchoolCurricula = () => {
  return (
    <section className="school-curricula-section">
      <div className="curricula-container">
        {}
        <div className="curricula-header-row">
          <h2 className="curricula-main-title">Sahara School Curricula</h2>
          <Link to="/Curriculum" className="btn btn-primary">
            VIEW ALL <FaArrowRight className="arrow-icon" />
          </Link>
        </div>

        {}
        <div className="curricula-description-wrapper">
          <p className="curricula-text-p">
            Sahara Public Secondary School offers a strong early years
            foundation through our comprehensive Pre-Primary programs and a
            structured SEE pathway from primary to Grade 12, helping students
            build academic confidence, crucial life skills, and long-term
            readiness.
          </p>
          <p className="curricula-text-p">
            We offer some of the most renowned curricula that build a solid
            educational foundation for students. Students are given high
            exposure to overall holistic development as our value-integrated
            learning framework is deeply embodied within every phase of the
            curriculum.
          </p>
          <p className="curricula-text-p">
            Recognized among the premium secondary schools in the region, Sahara
            focuses on fostering academic excellence along with life skills and
            global perspectives to prepare students for future real-world
            success.
          </p>
        </div>

        {}
        <div className="curricula-wings-grid">
          {}
          <div className="wing-card-item">
            <div className="wing-icon-logo-bg">
              {}
              <img
                src="/icon/primary.png"
                alt="Pre-Primary Icon"
                className="wing-brand-icon"
              />
            </div>
            <h3 className="wing-card-title">Pre-Primary Wing (Montessori)</h3>
            <p className="wing-card-desc">
              Our Montessori-inspired early childhood programme builds strong
              early foundations in literacy, numeracy, communication,
              creativity, and social development through interactive,
              child-centric learning.
            </p>
          </div>

          {}
          <div className="wing-card-item">
            <div className="wing-icon-logo-bg">
              {}
              <img
                src="/icon/nepal.png"
                alt="CBSE Icon"
                className="wing-brand-icon"
              />
            </div>
            <h3 className="wing-card-title">SEEB Pathway</h3>
            <p className="wing-card-desc">
              The SEE curriculum at Sahara Public Secondary School combines
              strict academic rigour with experiential learning, helping
              students build deep conceptual clarity, resilience, and
              future-ready skills from primary through high school.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SchoolCurricula;
